/**
 * App analytics configuration
 *
 * Supported analytics services:
 * - Google Analytics.
 *
 */
export const appAnalyticsConfig = {
  googleAnalyticsId: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID?.trim() ?? "",
};
